var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[_c('SnackBar',{ref:"SnackBar"}),_c('LoadingBar',{ref:"LoadingBar"}),(_vm.loading)?_c('Navigation'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }